import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {InlineSVGModule} from "ng-inline-svg-2";

@Component({
  selector: 'crm-generic-creat-modal',
  standalone: true,
  imports: [
    InlineSVGModule
  ],
  templateUrl: './generic-create-modal.component.html',
  styleUrl: './generic-create-modal.component.scss'
})
export class GenericCreateModalComponent {

  @Input({required: false}) iconSvg: string;
  @Input() title: string;
  @Input() description: string;
  @Output() close = new EventEmitter();

  // Emit close on ESC so consumers can handle confirmation or other actions
  @HostListener('document:keydown.escape', ['$event'])
  onEscKey(event: KeyboardEvent) {
    // Force blur to prevent unwanted focus
    document.activeElement instanceof HTMLElement && document.activeElement.blur();
    event.preventDefault()
    this.close.emit()
  }
}
